export default {
	SOUTH_DEVON_RAILWAY: 4,
	HOPS_HERITAGE_RAILWAYS: 6,
	HAMPTON_KEMPTON_WATERWORKS_RAILWAY: 307,
	HOPS_CYPRUS_RAILWAY: 504
};
